import { render, staticRenderFns } from "./ShipIowStatusWidget.vue?vue&type=template&id=520706fd&scoped=true"
import script from "./ShipIowStatusWidget.vue?vue&type=script&lang=js"
export * from "./ShipIowStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipIowStatusWidget.vue?vue&type=style&index=0&id=520706fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520706fd",
  null
  
)

export default component.exports